<template>
    <div>
    <!-- CONTENIDO PRINCIPAL -->
        <div class="container contenido_principal">
            <!-- ===Apartado de las cards=== -->
            <div class="seccion_cardsOpciones my-2">
                <div class="row px-1 d-flex align-items-center justify-content-between">
                    <div class="col-xs-12 col-sm-6 col-md-6">
                        <!-- <router-link :to="{name:'conocenos-directorio-secretaria-de-hacienda'}" class="nav-link"> -->
                          <a href="https://www.chiapas.gob.mx/funcionarios/estatal/ejecutivo/secretaria-hacienda" class="nav-link" target="_blank">
                            <div class="card mb-3 p-1">
                                <div class="row no-gutters d-flex">
                                    <div class="col-md-4 p-2 text-center justify-content-center">
                                        <i class="fas fa-address-book icono_card"></i>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body  justify-content-center">
                                            <h5 class="card-title titulo_subsec mb-4">Directorio</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                          </a>
                        <!-- </router-link>                                                                -->
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6">
                        <router-link :to="{name:'conocenos-mision-vision'}" class="nav-link">
                            <div class="card mb-3 p-1" >
                                <div class="row no-gutters">
                                    <!---Imagen de la card-->
                                    <div class="col-md-4 p-2 text-center justify-content-center" >
                                        <i class="fas fa-book-reader icono_card"></i>
                                    </div>
                                    <!---Texto de la card-->
                                    <div class=" col-md-8">
                                        <div class="card-body">
                                            <h5 class="card-title titulo_subsec mb-4">Misión y Visión</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </router-link>
                        <!--  -->
                    </div>
                </div>
                <div class="row px-1 d-flex align-items-center justify-content-between">
                    <div class="col-xs-12 col-sm-12 col-md-6">
                        <router-link :to="{name:'conocenos-organigrama'}" class="nav-link">
                            <div class="card mb-3 p-1">
                                <div class="row no-gutters d-flex">
                                    <div class="col-md-4 p-2 text-center justify-content-center">
                                        <i class="fas fa-sitemap icono_card"></i>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body  justify-content-center">
                                            <h5 class="card-title titulo_subsec mb-4">Organigrama</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </router-link>
                        <!--  -->
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-6">
                        <router-link :to="{name:'conocenos-reglamento-interior'}" class="nav-link">
                            <div class="card mb-3 p-1" id="seleccionado">
                                <div class="row no-gutters">
                                    <div class="col-md-4 p-2 text-center justify-content-center">
                                        <i class="fas fa-book icono_card"></i>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body">
                                            <h5 class="card-title titulo_subsec mb-4">Reglamento Interior</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </router-link>
                        <!--  -->
                    </div>
                </div>
                <!-- <div class="row px-1 d-flex align-items-center justify-content-between">
                    <div class="col-xs-12 col-sm-6 col-md-6">
                        <a target="_blank" class="nav-link" :href="urlServe+'conocenos/informacion/codigo/codigo-SH.pdf'">
                            <div class="card mb-3 p-1">
                                <div class="row no-gutters d-flex">
                                    <div class="col-md-4 p-2 text-center justify-content-center">
                                        <i class="far fa-file-alt icono_card"></i>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body  justify-content-center">
                                            <h5 class="card-title titulo_subsec mb-4">Código de Ética y Conducta de la Secretaría de Hacienda</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6">
                        <a target="_blank" class="nav-link" :href="urlServe+ 'conocenos/informacion/codigo/codigo.pdf'">
                            <div class="card mb-3 p-1">
                                <div class="row no-gutters d-flex">
                                    <div class="col-md-4 p-2 text-center justify-content-center">
                                        <i class="fas fa-tasks icono_card"></i>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body  justify-content-center">
                                            <h5 class="card-title titulo_subsec mb-4">Código de Honestidad y Ética de los Servidores Públicos de la Administración Pública del Estado de Chiapas</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div> -->
                <div class="row px-1 d-flex align-items-center justify-content-between">
                    <div class="col-xs-12 col-sm-12 col-md-6">
                        <router-link :to="{name:'conocenos-programas-institucionales'}" class="nav-link">
                            <div class="card mb-3 p-1" >
                                <div class="row no-gutters">
                                    <div class="col-md-4 p-2 text-center justify-content-center" >
                                        <i class="fas fa-building icono_card"></i>
                                    </div>
                                    <div class=" col-md-8">
                                        <div class="card-body">
                                            <h5 class="card-title titulo_subsec mb-4">Programa Institucional</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-6">
                        <router-link :to="{name:'conocenos-indicadores-de-gestion'}" class="nav-link">
                            <div class="card mb-3 p-1" id="seleccionado">
                                <div class="row no-gutters">
                                    <div class="col-md-4 p-2 text-center justify-content-center">
                                        <i class="fas fa-chart-line icono_card"></i>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body">
                                            <h5 class="card-title titulo_subsec mb-4">Indicadores de Gestión</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    methods:{

    }
}
</script>
